<section class="content">
  <div class="container-fluid">
    <div class="block-header">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <ul class="breadcrumb breadcrumb-style ">
            <li class="breadcrumb-item">
              <h4 class="page-title">Basic Form</h4>
            </li>
            <li class="breadcrumb-item bcrumb-1">
              <a routerLink="/dashboard/main">
                <i class="fas fa-home"></i> Home</a>
            </li>
            <li class="breadcrumb-item bcrumb-2">
              <a href="#" onClick="return false;">Forms</a>
            </li>
            <li class="breadcrumb-item active">Basic</li>
          </ul>
        </div>
      </div>
    </div>
    <app-maser-page-header></app-maser-page-header>
    <table class="table table-dark" style="margin-top: 15px;">
      <thead>
        <tr>
          <th scope="col"></th>
          <th *ngFor="let product of discount_products" scope="col">{{product['name']}} - Rs.{{product['mrp']}}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let icustomer_type of icustomer_types">
          <th scope="row">{{icustomer_type['name']}}</th>
          <td *ngFor="let product of discount_products"
            (click)="openDialog(icustomer_type['id'], icustomer_type['name'], product['id'], product['name'], discountPrice(icustomer_type['id'], product['id']))">
            {{discountPrice(icustomer_type['id'], product['id'])}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</section>